<section>
  <h1 role="text"
    [attr.aria-label]="resources?.MessageServicePageNotFound"
    [attr.title]="resources?.MessageServicePageNotFound">
    {{ resources?.MessageServicePageNotFound }}
  </h1>
</section>
